import React, { useEffect, useRef, useState } from 'react';
import { whoWeServeData } from '../data/mock';
import { Hammer, Truck, Store, Mountain } from 'lucide-react';

const iconMap = {
  Hammer: Hammer,
  Truck: Truck,
  Store: Store,
  Mountain: Mountain
};

const WhoWeServeSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const currentSection = sectionRef.current;
    
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className={`text-center mb-16 transform transition-all duration-700 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {whoWeServeData.title}
            </h2>
            {whoWeServeData.subtitle && (
              <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
                {whoWeServeData.subtitle}
              </p>
            )}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {whoWeServeData.segments.map((segment, index) => {
              const IconComponent = iconMap[segment.icon];
              return (
                <div
                  key={index}
                  className={`group bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-gray-100 hover:border-green-500 transform ${
                    isVisible 
                      ? 'translate-y-0 opacity-100' 
                      : 'translate-y-10 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 100 + 200}ms` }}
                >
                  <div className="mb-4 inline-block p-4 bg-green-100 rounded-full">
                    <IconComponent className="w-8 h-8 text-green-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {segment.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-base">
                    {segment.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeServeSection;
